export default {
    template:   require('./error-message.vue')
};
